/**
 * 歌手标签
 * */
import React, { useCallback } from 'react';
import Util from '../../../script/util';
import './GodScoreLevelTag.scss';

const GodScoreLevelTag = ({ pic, width, height, ...props }) => {
  const godScoreTag = useCallback(() => {
    return Util.transImgUrl(pic, '100x30');
  }, [pic]);

  return (
    <span className="god-score-level-tag" style={{ width, height }} {...props}>
      {/* 大神分标签 */}
      <img src={godScoreTag()} alt="" />
    </span>
  );
};

GodScoreLevelTag.defaultPorps = {
  width: 60,
  height: 18,
};

export default GodScoreLevelTag;
